import { AlertOctagon, RefreshCcw } from 'lucide-react';

/**
 * Rendered by Sentry's ErrorBoundary when an unhandled render-time error escapes a
 * descendant component. Static markup only — no API calls, no dynamic state — because the
 * component tree above us has crashed and we want a guaranteed-safe surface.
 */
export function SentryFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white border border-gray-200 rounded-3xl shadow-sm p-8 sm:p-10 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-red-50 flex items-center justify-center mb-6">
          <AlertOctagon className="w-8 h-8 text-red-700" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-display font-bold text-brand-primary mb-3">
          Something went wrong
        </h1>
        <p className="text-brand-muted font-medium mb-8 leading-relaxed">
          Our team has been notified. Try reloading the page — if the problem persists,
          come back in a few minutes.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-brand-primary text-white rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-brand-deep transition-all"
        >
          <RefreshCcw className="w-4 h-4" />
          Reload page
        </button>
      </div>
    </div>
  );
}
